














































































































import { defineComponent, ref, useContext } from "@nuxtjs/composition-api";
import { filter, isEmpty, map } from "lodash-es";
import { useGtm } from "~/composables";
import { getLocalizedPath, isExternalUrl } from "~/helpers/getLocalizedPath";

import MenuSubList from './MenuSubList.vue';
export default defineComponent({
  name: "MenuItemSub",
  components: {
    MenuSubList
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    menu: {
      type: Object,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => {},
    },
  },
  setup(props) {
    const { app: { i18n } } = useContext();
    const { eventCustomlinksInteracted } = useGtm();
    const subCat1 = ref([]);
    const subCat2 = ref([]);
    const activeItemKey = ref(null);
    const showChildMenu = function (key) {
      activeItemKey.value = key;
    };

    if (props.menu.url_key === "products-applications") {
      subCat1.value = filter(
        props.menu.children,
        (item) => !isEmpty(item.children)
      );
      subCat2.value = filter(props.menu.children, (item) =>
        isEmpty(item.children)
      );
    } else {
      const subMenu = map(props.menu.children, (item) => {
        item.children = [];
        return item;
      });
      subCat1.value = filter(subMenu, (item) => !isEmpty(item.children));
      subCat2.value = filter(subMenu, (item) => isEmpty(item.children));
    }

    const navigationTracking = (menu) => {
      eventCustomlinksInteracted({
        "eventlabel": menu.title,
        "eventCategory": "Primary Navigation Links",
      });
    };
    const getMenuLink = (urlKey) => getLocalizedPath(urlKey, i18n);

    return {
      subCat1,
      subCat2,
      showChildMenu,
      activeItemKey,
      navigationTracking,
      getMenuLink,
      isExternalUrl,
    };
  },
});
